import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-female-tai-chi-walking-v2': {
			// ?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2&exp=web_tai_chi_walking_v2_lee_as_a_model~1
			landing: {
				experiment: () => import('@/modules/Landing/instances/experiments/web_tai_chi_walking_v2_lee_as_a_model'),
			},
			funnel: {
				id: 'ob-female-tai-chi-walking-lee-as-model',
				locale: ['en'],
			},
		},
	},
]

export default config
